<template>
    <Transition name="fade" @after-enter="$emit('after-enter', $event)">
        <slot></slot>
    </Transition>
</template>

<script>
export default {
    name: 'fade-transition'
}
</script>

<style lang="scss" scoped>

.fade-enter-active {
    animation: fadeIn .25s ease-out forwards;
}
.fade-leave-active {
    animation: fadeOut .15s ease-in forwards;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    } to {
        opacity: 1;
    }
}
@keyframes fadeOut {
    0% {
        scale: 1;
    } 100% {
        opacity: 0;
    }
}
    
</style>